import React, { Fragment } from 'react'
import { Home } from 'react-feather'
import PropTypes from "prop-types"
import Layout from '../@core/layouts/VerticalLayout'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { usePage } from '@inertiajs/inertia-react'

const VerticalLayout = ({ children }) => {

  const store = useSelector(state => state)

  const { auth: { user, projects, projectsList, dealsList } } = usePage().props

  const { company } = user

  const navbarStore = store.navbar
  const contentWidth = store.layout.contentWidth
  const transition = store.layout.routerTransition
  const layoutStored = store.layout.layout
  const resourcesMenuDataHeader = company?.type === "Investor" ? "Investor Tools" : company?.type === "Promoter" ? "Developer Tools" : ""

  const appLayoutCondition =
    (layoutStored.layout === 'horizontal' && false) ||
    (layoutStored.layout === 'horizontal' && false)
  const Tag = appLayoutCondition ? 'div' : Fragment

  const navigationMenuData = [
    {
      id: 'dashboard',
      title: 'Dashboard',
      icon: <Home size={20} />,
      navLink: '/home',
    },
  ]

  const adminData = [
    { header: 'CRM' },
    {
      id: 'companies',
      title: 'Companies',
      navLink: route('companies.index'),
    },
    {
      id: 'projects',
      title: 'Projects',
      navLink: route('projects.index'),
      route: 'projects.index'
    },
    {
      id: 'share',
      title: 'Share',
      navLink: route('admin.share.index'),
      route: 'admin.share.index'
    },
    {
      id: 'search',
      title: 'Search',
      navLink: route('admin.search.index'),
      route: 'admin.search.index'
    },
    { header: 'Backoffice' },
    {
      id: 'forms',
      title: 'Forms',
      navLink: route('forms.index'),
    },
  ]

  const resourcesMenuData = [
    {
      header: resourcesMenuDataHeader,
    },
  ]

  const promoterMenuData = [
    {
      id: 'projects-category',
      title: 'Projects',
      children: [
        {
          id: 'new-project',
          title: 'New project',
          navLink: route('promoter.projects.create'),
        },
        {
          id: 'my-projects',
          title: 'My projects',
          navLink: route('promoter.projects.index'),
          badge: 'light-warning',
          badgeText: projects,
        },
      ]
    },
    {
      id: 'generate',
      title: 'Generate',
      navLink: route('generate.index'),
    },
    {
      id: 'share',
      title: 'Share',
      navLink: route('share.index'),
    },
    {
      id: 'engage',
      title: 'Engage',
      ...(projectsList?.length > 0 ? {
        children: projectsList.map((project) => ({
          id: `engage-project-${project.id}`,
          title: project.message_count > 0 ? `Project ID ${project.id} (${project.message_count})` : `Project ID ${project.id}`,
          navLink: route('promoter.engage.show', { project: project.id }),
          small: true,
        })),
      } : { navLink: '#' }),
    },
  ]

  const investorMenuData = [
    {
      id: 'vehicles-category',
      title: 'Vehicles',
      children: [
        {
          id: 'new-vehicle',
          title: 'New vehicle',
          navLink: route('investor.projects.create'),
        },
        {
          id: 'my-vehicles',
          title: 'My vehicles',
          navLink: route('investor.projects.index'),
          badge: 'light-warning',
          badgeText: projects,
        },
      ]
    },
    {
      id: 'search',
      title: 'Search',
      navLink: route('investor.search.index'),
    },
    {
      id: 'my-deals',
      title: 'My Deals',
      ...(dealsList?.length > 0 ? {
        children: [
          {
            id: 'see-all-deals',
            title: 'See All',
            navLink: route('investor.deals.index'),
          },
          ...dealsList.map((deal) => ({
            id: `deal-${deal.id}`,
            title: deal.name,
            navLink: route('investor.deals.show', { deal: deal.id }),
            small: true,
          })),
        ],
      } : { navLink: route('investor.deals.index') }),
    },
  ]

  const menuData = []

  if (projects > 0 || user?.role === "Admin") menuData.push(...navigationMenuData)

  if (user?.role === "Admin") menuData.push(...adminData)

  if (projects > 0) menuData.push(...resourcesMenuData)

  if (company?.type === "Investor") menuData.push(...investorMenuData)
  else if (company?.type === "Promoter") menuData.push(...promoterMenuData)

  return (
    <Layout menuData={menuData}>
      <div
        className={classnames('app-content content overflow-hidden', {
          ['']: '',
          'show-overlay': navbarStore.query.length
        })}
      >
        <div className='content-overlay'></div>
        <div className='header-navbar-shadow' />
        <div
          className={classnames({
            'content-wrapper': false,
            'content-area-wrapper': false,
            'container-xxl p-0': contentWidth === 'boxed',
            [`animate__animated animate__${transition}`]: transition !== 'none' && transition.length
          })}
        >
          <Tag {...(appLayoutCondition ? { className: 'content-body' } : {})}>{children}</Tag>
        </div>
      </div>
    </Layout>
  )
}

export default VerticalLayout

VerticalLayout.propTypes = {
  children: PropTypes.object
}
